<template>
    <b-card no-body>
        <b-card-header class="border-0 flex flex-row">
            <div class="job-group-history-filters">
                <base-input label="Name" placeholder="Name" v-model="filters.job_group__name__icontains" />
                <!-- <base-input label="Start time from"> -->
                    <timestamp-picker field="start_time__gte" label="Start time from" @change="dateChanged" />
                <!-- </base-input> -->
                <!-- <base-input label="Start time to"> -->
                    <timestamp-picker field="start_time__lte" label="Start time to" @change="dateChanged" />
                <!-- </base-input> -->
                <!-- <base-input label="End time from">
                    <timestamp-picker field="end_time__gte" @change="dateChanged" />
                </base-input>
                <base-input label="End time to">
                    <timestamp-picker field="end_time__lte" @change="dateChanged" />
                </base-input> -->
                
            </div>
            <base-button icon type="info" @click="getPage(currentPage)">
                <span class="btn-inner--icon">
                    <b-icon icon="arrow-counterclockwise" font-scale="2"></b-icon>
                </span>
            </base-button>
            
        </b-card-header>
        <div v-if="isLoading">
            <card>Loading...</card>
        </div>
        <template v-else>
            <el-table class="table-responsive table"
                    header-row-class-name="thead-light"
                    :data="jobGroupHistories">
                <el-table-column label="Job Group" prop="job_group" />
                <el-table-column label="Start time" prop="start_time" :formatter="formatDefaultDateTable" />
                <el-table-column label="Details" prop="_">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center justify-content-end">
                            <router-link v-bind:key="row.id" :to="'/job_group_history/'+row.id">
                                <base-button icon type="info">
                                    <span class="btn-inner--icon">
                                        <i class="ni ni-align-center"/>
                                    </span>
                                </base-button>
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination v-model="currentPage" :per-page="20" :total="total" @change="pageChanged">
                    <template v-slot:prev-text>
                        <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                        </a>
                    </template>
                </base-pagination>
            </b-card-footer>
        </template>
        
    </b-card>
</template>

<script>
import {Table,TableColumn} from 'element-ui'
import TimestampPicker from '@/components/TimestampPicker.vue'

import RepositoryFactory from "@/repositories/RepositoryFactory"

const JobGroupHistoryRepository = RepositoryFactory.get('job_group_log')

export default {
    name:'job-group-history-table',
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
        [TimestampPicker.name]:TimestampPicker,
    },
    created(){
        this.getPage(this.currentPage)
    },
    data(){
        return {
            currentPage: 1,
            total:0,
            jobGroupHistories:null,
            lastRequestTimestamp:0,

            isLoading:true,

            filters:{
                category:undefined,
            },
            filterTimer:undefined, // Filtre her inputta değil kullanıcı yazmayı bıraktığında çalışsın diye
        }
    },
    watch:{
        filters:{
            handler(oldVal,newVal){
                clearTimeout(this.filterTimer);
                this.isLoading=true;
                for(var i in this.filters){
                    if(this.filters[i]==="")
                        delete this.filters[i]
                    }
                this.filterTimer=setTimeout(() => this.filterTable(), 1000);
            },
            deep:true,
        }
    },
    methods:{
        getPage(pageNumber){
            var timestamp=Date.now();
            this.lastRequestTimestamp=timestamp;

            this.isLoading=true;
            this.currentPage=pageNumber;
            JobGroupHistoryRepository.getTable(pageNumber, this.filters).then((response) => {
                if(this.lastRequestTimestamp!==timestamp) return;

                var r=response.data;
                
                this.jobGroupHistories=r.results;
                this.total=r.count;
                this.currentPage=pageNumber;

                for(var i in this.jobGroupHistories){
                    if (this.jobGroupHistories[i].start_time!==null && this.jobGroupHistories[i].start_time!==undefined)
                        this.jobGroupHistories[i].start_time=this.timestampToDatetime(this.jobGroupHistories[i].start_time);
                    
                    if (this.jobGroupHistories[i].end_time!==null && this.jobGroupHistories[i].end_time!==undefined)
                        this.jobGroupHistories[i].end_time=this.timestampToDatetime(this.jobGroupHistories[i].end_time);
                    
                    if(this.jobGroupHistories[i].job_group===null)
                        this.jobGroupHistories[i].job_group="Malformed data"
                }

                this.isLoading=false;
            })
        },
        pageChanged(pageNumber){
            this.getPage(pageNumber);
        },
        dateChanged(data){
            var filterField = data[0];
            if(data[1]===0)
                delete this.filters[filterField];
            else
                this.filters[filterField]=data[1];
            
            this.filterTable();
        },
        filterTable(){
            this.isLoading=true;
            this.getPage(1);
        }
    }
}
</script>

<style>

.job-group-history-filters{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap:10px;
}

</style>